export enum TicketEntityType {    
    Unknown = 0,
    DashRegistrationUser = 1,
    User = 2,
    GeneralPublic = 3,
    Center = 4
}